import { render } from "./Building.vue?vue&type=template&id=af8592e6&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"

import "./Building.vue?vue&type=style&index=0&id=af8592e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af8592e6"

export default script